// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */

import { isolateComponent } from '@zapier/common-utils';
import { Colors, IconButton } from '@zapier/design-system';

/** @jsx isolateComponent */

type Props = {
  /*
   * `aria-label` for the `IconButton` if `label` isn't supplied.
   */
  ariaLabel?: string,
  /**
   * `id` of the `input` that this component points to.
   */
  id?: string,
  /**
   * Indicates whether the user is currently searching.
   */
  isSearching: boolean,
  /*
   * Label for the `IconButton`.
   */
  label?: string,
};

const SearchIconButtonTheme = {
  custom: {
    base: {
      backgroundColor: 'transparent',
      color: Colors.grey700,
    },
    disabled: {
      backgroundColor: 'transparent',
      color: Colors.grey100,
    },
    hover: {
      backgroundColor: Colors.grey100,
      color: Colors.grey700,
    },
    focus: {
      backgroundColor: Colors.grey100,
      color: Colors.grey700,
      outlineColor: Colors.transparent,
    },
  },
};

const SearchToggler = (props: Props) => {
  return (
    <IconButton
      /*
      The search form is friendlier for screenreader users
      without these buttons.
      */
      ariaHidden={true}
      ariaLabel={props.ariaLabel}
      color="custom"
      colorTheme={SearchIconButtonTheme}
      htmlFor={props.id}
      icon={props.isSearching ? 'formX' : 'magnifyingGlass'}
      iconSize={24}
      isPill={true}
      label={props.label}
      shouldCorrectTooltipPosition={false}
      tooltipPosition="south"
    />
  );
};

export default SearchToggler;
